import { render, staticRenderFns } from "./businessCard.vue?vue&type=template&id=5de09cd2&scoped=true&"
import script from "./businessCard.vue?vue&type=script&lang=js&"
export * from "./businessCard.vue?vue&type=script&lang=js&"
import style0 from "./businessCard.vue?vue&type=style&index=0&id=5de09cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de09cd2",
  null
  
)

export default component.exports